import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/yj/login';
import home from '@/components/yj/home';

import trade from '@/components/yj/trade';
import market from '@/components/yj/market';
import search from '@/components/yj/search';
import tradeDetail from '@/views/TradeDetail/TradeDetail';
import condition from '@/views/condition/condition.vue';
import person from '@/views/Person/Person';

import recharge from '@/views/Person/Recharge/Recharge';
import drawmoney from '@/views/Person/DrawMoney/DrawMoney';
import bankCar from '@/views/Person/DrawMoney/BankCar/BankCar';
// import record from '@/views/Person/Record/Record';
import rechargerecord from '@/views/Person/RechargeRecord/RechargeRecord';
import drawmoneyrecord from '@/views/Person/DrawMoneyRecord/DrawMoneyRecord';
import details from '@/views/Person/DrawMoneyRecord/Details/Details';

import kLine from '@/components/common/kLine';

import marketDetail from '@/components/yj/marketDetail';
import userProtocol from '@/components/yj/userProtocol';
import select from '@/components/yj/targetSelected';
import setPage from '@/components/yj/setPage';
Vue.use(Router);
const router=new Router({

  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      // redirect: '/home/trade'
    },
    {
      path: '/test',
      name: 'test',
      component: ()=>import('@/components/common/Test/Test.vue'),
      // redirect: '/home/trade'
    },
    // {
    //   path: '/test1',
    //   name: 'test1',
    //   component: ()=>import('@/components/test/condition_test.vue'),
    //   // redirect: '/home/trade'
    // },
    {
      path: '/home',
      name: 'home',
      component: home,
      // redirect: '/home/trade',
      children: [
        {
          path: 'trade',
          name: 'trade',
          component: trade
        },
        {
          path: 'market',
          name: 'market',
          component: market
        },
        {
          path: 'select',
          name: 'select',
          component: select
        },
        {
          path: 'condition',
          name: 'condition',
          component: condition
        },
        {
          path: 'search',
          name: 'search',
          component: search
        },
        {
          path: 'person',
          name: 'person',
          component: person,
        },
      ]
    },
    {
      path: '/tradeDetail/:tableId',
      name: 'tradeDetail',
      component: tradeDetail
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
    },
    {
      path: '/drawmoney/:availablemoney?',
      name: 'drawmoney',
      component: drawmoney,
    },
    {
      path: '/bankCar',
      name: 'bankCar',
      component: bankCar,
    },
    {
      path: '/rechargerecord',
      name: 'rechargerecord',
      component: rechargerecord,
    },
    {
      path: '/drawmoneyrecord',
      name: 'drawmoneyrecord',
      component: drawmoneyrecord,
    },
    {
      path: '/details',
      name: 'details',
      component: details,
    },
    {
      path: '/ChangeWord',
      name: 'ChangeWord',
      component: () => import('@/views/ChangeWord/ChangeWord')
    },
    {
      path: '/kLine',
      name: 'kLine',
      component: kLine
    },
    {
      path: '/marketDetail/:contract',
      name: 'marketDetail',
      component: marketDetail
    },
    {
      path: '/userProtocol',
      name: 'userProtocol',
      component: userProtocol
    },
    {
      path: '/setPage',
      name: 'setPage',
      component: setPage
    }

  ]
});

const mainTabPaths = [
  '/home/select',
  '/home/market',
  '/home/trade',
  '/home/condition',
  '/home/search'
];

function isMainTabPath(path) {
  return mainTabPaths.indexOf(path) > -1;
}

function handleAppBack() {
  const currentRoute = router.currentRoute || {};
  const currentPath = currentRoute.path || '/';

  if (currentPath === '/') {
    if (window.navigator &&
      window.navigator.app &&
      typeof window.navigator.app.exitApp === 'function') {
      window.navigator.app.exitApp();
      return 'exit';
    }
    return 'stay';
  }

  if (isMainTabPath(currentPath)) {
    window.footerIndex = 0;
    router.replace({ path: '/' });
    return 'login';
  }

  router.back();
  return 'back';
}

window.__appHandleBack = handleAppBack;

document.addEventListener('deviceready', () => {
  document.addEventListener('backbutton', event => {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    handleAppBack();
  }, false);
}, false);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js